import axios from 'axios'
import endpoint from './endpoint'

/**
 * API functions for addressQuery
 */
export default {
  /**
   * Read API
   *
   * @param headers: object
   * @param id: string
   */
  search(payload) {
    let params = payload.params;
    let esc = encodeURIComponent;
    let query = Object.keys(params).map(k => esc(k) + '=' + esc(params[k])).join('&');
    return new Promise((resolve, reject) => {
      axios.get(endpoint.addressQuery + '?' + query, {
        headers: {
          'Accept': 'application/json',
          'Accept-Language': 'en, zh-Hant'
        }
      }).then(res => {
        resolve(res.data);
      })
    });
  },
}
